import { FeedbacksContainer } from '@/modules/Feedbacks';

const Feedbacks = (): JSX.Element => <FeedbacksContainer />;

export default Feedbacks;
